<template>
  <div class="content">
      <!-- <video class="background" style="
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  margin-bottom: -3px;" src="../../assets/bg-0517.mp4" autoplay loop muted></video> -->
    <div class="body">
      <div class="custom-carousel" ref="carousel">
        <div class="carousel-wrapper" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
          <div class="carousel-page">
            <div class="con1" v-if="data.length > 0">
              <div
                class="list"
                v-for="(item, i) in data.filter((e, index) => index % 2 === 0).slice(0, 15)" :key="item.id"
                :style="{
                  top: i * topPosition + '%',
                  zIndex: i,
                  height: topPosition + '%'
                }"
              >
                <div class="item-inner paiming">
                  <div class="paiming-number">{{i * 2 + 1}}</div>
                </div>
                <div class="item-inner logo">
                  <!-- <img v-if="i === 0" class="huangguan" src="../../assets/huangguan.png"> -->
                  <img :src="item.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`">
                </div>
                <div :class="`item`">
                  <div class="item-inner total">
                    <div class="item-inner nickname">
                      <span>{{item.nickname }}</span>
                    </div>
                    <div class="total-inner">
                      <span>￥{{ parseInt(item.total.toFixed(0)) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="con2" v-if="data.length > 1">
              <div
                class="list"
                v-for="(item, i) in data.filter((e, index) => index % 2 !== 0).slice(0, 15)" :key="item.id"
                :style="{
                  top: i * topPosition + '%',
                  zIndex: i,
                  height: topPosition + '%'
                }"
              >
                <div class="item-inner paiming">
                  <div class="paiming-number">{{(i + 1) * 2}}</div>
                </div>
                <div class="item-inner logo">
                  <!-- <img v-if="i === 0" class="huangguan" src="../../assets/huangguan.png"> -->
                  <img :src="item.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`">
                </div>
                <div :class="`item`">
                  <div class="item-inner total">
                    <div class="item-inner nickname">
                      <span>{{item.nickname }}</span>
                    </div>
                    <div class="total-inner">
                      <span>￥{{ parseInt(item.total.toFixed(0)) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-page">
            <div class="con1" v-if="data.length > 0">
              <div
                class="list"
                v-for="(item, i) in data.filter((e, index) => index % 2 === 0).slice(15)" :key="item.id"
                :style="{
                  top: i * topPosition + '%',
                  zIndex: i,
                  height: topPosition + '%'
                }"
              >
                <div class="item-inner paiming">
                  <div class="paiming-number-gray">{{i * 2 + 31}}</div>
                </div>
                <div class="item-inner logo">
                  <img :src="item.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`">
                </div>
                <div :class="`item`">
                  <div class="item-inner total total-page2">
                    <div class="item-inner nickname">
                      <span>{{item.nickname }}</span>
                    </div>
                    <div class="total-inner">
                      <span>￥{{ parseInt(item.total.toFixed(0)) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="con2" v-if="data.length > 0">
              <div
                class="list"
                v-for="(item, i) in data.filter((e, index) => index % 2 !== 0).slice(15)" :key="item.id"
                :style="{
                  top: i * topPosition + '%',
                  zIndex: i,
                  height: topPosition + '%'
                }"
              >
                <div class="item-inner paiming">
                  <div class="paiming-number-gray">{{(i + 16) * 2}}</div>
                </div>
                <div class="item-inner logo">
                  <img :src="item.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`">
                </div>
                <div :class="`item`">
                  <div class="item-inner total total-page2">
                    <div class="item-inner nickname">
                      <span>{{item.nickname }}</span>
                    </div>
                    <div class="total-inner">
                      <span>￥{{ parseInt(item.total.toFixed(0)) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-indicators">
      <span
        v-for="(page, index) in 2"
        :key="index"
        :class="{ active: currentIndex === index }"
        @click="goToPage(index)"
      >{{index +1}}</span>
    </div>
    <div class="pause-con">
      <button @click="pauseClick">{{ pause ? '启动' : '暂停'}}</button>
    </div>
  </div>
</template>
 
<script>
import { cloneDeep } from 'lodash'
import userList from './selected-data.js'
import mockData from './mock.js'
import axios from '../axios-instance'
import moment from 'moment'

const limit = 6.5

export default {
  name: 'page0517',
  watch: {
  },
  data () {
    return {
      data: [
      ],
      data2: [],
      data3: [],
      maxNum: 10000,
      maxNum2: 10000,
      maxNum3: 10000,
      currentDate: moment().format('MM月DD日'),
      topPosition: limit,
      interval: undefined,
      heigth: limit,
      limit,
      animating: false,
      animating2: false,
      animating3: false,
      pendingData: [],
      subscription: null,
      stompClient: null,
      init: false,
      itemWidth: 50,
      userList: [],
      startTime: null,
      endTime: null,
      imgList: {},
      touxiang: require('../../assets/touxiang.png'),
      dayTotal: 0,
      monthTotal: 0,
      currentIndex: 0,
      carouselInterval: null,
      pause: false
    }
  },
  created () {
  },
  mounted () {
    this.interval = setInterval(() => {
      this.getAllData()
    }, 20000)
    // this.getAllUserInfo().then(() => {
    this.getAllData(true)
    // this.getTestData()
    // })
    this.startAutoPlay()
  },
  beforeDestroy () {
    clearInterval(this.interval)
    clearInterval(this.carouselInterval)
  },
  methods: {
    pauseClick () {
      this.pause = !this.pause
      if (this.pause) {
        clearInterval(this.carouselInterval)
      } else {
        this.startAutoPlay()
      }
    },
    startAutoPlay () {
      this.carouselInterval = setInterval(() => {
        this.nextPage()
      }, 5000)
    },
    nextPage () {
      this.currentIndex = (this.currentIndex + 1) % 2
    },
    goToPage (index) {
      this.currentIndex = index
    },
    getAllUserInfo (type) {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/cyber-star/getAll`,
        method: 'get',
        headers: {
          'tenant-id': 1
        }
      })
        .then((res) => {
          console.log('所有主播数据：', res.data)
        })
    },
    getWidth (total, i) {
      let a = (total || 100) / this.maxNum * 70
      if (a > 20 && a < 30) {
        a = 30 - i
      }
      if (a < 20) {
        a = 20 - i / 2
      }
      return `${a}%`
    },
    getTestData () {
      const data = mockData
      this.loaded(data, true)
    },
    getAllData (isFirst) {
      const lastRequestTime = window.localStorage.getItem('requestTime0517')
      if (lastRequestTime && moment().valueOf() - lastRequestTime < 9000) {
        this.loaded(JSON.parse(window.localStorage.getItem('cacheData0517') || '{}'), isFirst)
        return false
      }
      this.getData().then((res) => {
        console.log('日志数据：', res)
        if (res && res.data.code === 0) {
          window.localStorage.setItem('requestTime0517', moment().valueOf())
          window.localStorage.setItem('cacheData0517', JSON.stringify(res.data.data))
          this.loaded(res.data.data, isFirst)
        } else {
          this.loaded(JSON.parse(window.localStorage.getItem('cacheData0517') || '{}'), isFirst)
        }
      }).catch((e) => {
        console.error(e)
        this.loaded(JSON.parse(window.localStorage.getItem('cacheData0517') || '{}'), isFirst)
      })
    },
    loaded (data, isFirst) {
      let total = 0
      const res = cloneDeep(userList).filter((item) => data[item.id] !== undefined).map((item, i) => {
        item.total = data[item.id] || 0
        total += item.total
        return item
      })
      this.dayTotal = total
      res.sort((a, b) => b.total - a.total)

      this.topPosition = this.limit

      if (isFirst) {
        this.data = res.map((item, i) => ({...item, total: 0}))
      }
      this.dealData(this.data, res, isFirst)
    },
    getData () {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/cyber-star/yiYiToday`,
        method: 'get',
        headers: {
          'Content-Type': 'form-data/x-www-form-urlencoded'
        }
      })
    },
    dealData (data, newData, isFirst) {
      if (data && data.length) {
        data.sort((a, b) => a.id - b.id)
        newData.sort((a, b) => a.id - b.id)
        newData.forEach((item, index) => {
          item.newNumber = item.total
          item.total = data[index].total
        })
      } else {
        newData.forEach((item, index) => {
          item.newNumber = item.total
          item.total = 0
        })
      }
      if (newData && newData.length) {
        newData.sort((a, b) => b.newNumber - a.newNumber)
        newData.forEach((item, index) => {
          item.numOnce = this.getOnce(item.newNumber, item.total)
        })
      }
      this.data = newData
      this.intervalFn(isFirst)
    },
    intervalFn (isFirst) {
      let i = 0
      this.animating = true
      const interval = setInterval(() => {
        i++
        this.data = this.data.map(item => {
          if (item.total !== item.newNumber) {
            item.total = item.total + item.numOnce
          }
          return item
        })
        if (i >= 40) {
          clearInterval(interval)
          this.animating = false
        }
      }, 50)
    },
    dealData2 (data, newData, isFirst) {
      if (data && data.length) {
        data.sort((a, b) => a.id - b.id)
        newData.sort((a, b) => a.id - b.id)
        newData.forEach((item, index) => {
          item.newNumber = item.total
          item.total = data[index].total
        })
      } else {
        newData.forEach((item, index) => {
          item.newNumber = item.total
          item.total = 0
        })
      }
      if (newData && newData.length) {
        newData.sort((a, b) => b.newNumber - a.newNumber)
        newData.forEach((item, index) => {
          item.numOnce = this.getOnce(item.newNumber, item.total)
        })
      }
      this.data2 = newData
      this.intervalFn2(isFirst)
    },
    intervalFn2 (isFirst) {
      let i = 0
      this.animating2 = true
      const interval = setInterval(() => {
        i++
        this.data2 = this.data2.map(item => {
          if (item.total !== item.newNumber) {
            item.total = item.total + item.numOnce
          }
          return item
        })
        if (i >= 40) {
          clearInterval(interval)
          this.animating2 = false
        }
      }, 50)
    },
    getOnce (n, o) {
      if (n !== o) {
        return (n - o) / 40
      }
      return 0
    }
  }
}
</script>
<style scoped>
.content {
  position: relative;
  width: 3000px;
  height: 1200px;
  font-size: 22px;
  background: green;
}

.body {
  position: relative;
  width: 54%;
  height: 97%;
  overflow: hidden;
  left: 23%;
  top: 0;
  padding-top: 1%;
}

.custom-carousel {
  width: 100%;
  height: 100%;
  position: relative;
}

.carousel-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease-in-out;
}

.carousel-page {
  display: flex;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  position: relative;
}

.con1 {
  position: absolute;
  top: 0;
  left: 10%;
  height: 100%;
  width: 38%;
}

.con2 {
  position: absolute;
  top: 0;
  left: 52%;
  height: 100%;
  width: 38%;
}

.list {
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
}

.paiming {
  display: flex;
  align-items: center;
  height: calc(100% - 10px);
  color: #ffd700;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.paiming-number {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgb(255 132 132) 0%, rgb(255 79 79) 50%, rgb(255 45 45) 100%);
  line-height: 30px;
  font-weight: bold;
  color: #fff;
  box-shadow: 
    0 0 8px rgba(255, 0, 0, 0.6),
    inset 0 1px 0 rgba(255, 255, 255, 0.7);
  border: 1px solid #ff9494;
}

.paiming-number-gray {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgb(187 187 187) 0%, rgb(146 142 138) 50%, rgb(126 123 120) 100%);
  line-height: 30px;
  font-weight: bold;
  color: #fff;
  box-shadow: 
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(150, 150, 150, 0.5);
}

.logo {
  display: flex;
  align-items: center;
  height: 70%;
  margin: 0 10px;
  width: auto;
  aspect-ratio: 1/1;
  position: relative;
}

.huangguan {
  position: absolute;
  top: -47%;
  left: -16%;
  height: 80%;
  width: auto;
}

.touxiang {
  width: 100%;
  height: auto;
  border: 1px solid #fff;
  border-radius: 50%;
}

.item {
  position: relative;
  color: #fff;
  width: 100%;
  height: 65%;
  display: flex;
  flex-direction: row;
}

.total {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 30px;
  width: 100%;
  text-align: right;
  justify-content: space-between;
  line-height: 18px;
  box-sizing: border-box;
  position: relative;
  border: 2px solid #ff9494;
  border-radius: 8px;
  background: linear-gradient(135deg, rgb(255 132 132) 0%, rgb(255 79 79) 50%, rgb(255 45 45) 100%);
  padding: 0 8px;
  box-shadow: 
    0 0 10px rgba(255, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.5),
    0 2px 4px rgba(0, 0, 0, 0.2);
}

.total-page2 {
  background: linear-gradient(135deg, rgb(187 187 187) 0%, rgb(146 142 138) 50%, rgb(126 123 120) 100%);
  border-color: rgba(160, 155, 150, 0.5);
  box-shadow: 
    inset 0 1px 0 rgba(255, 255, 255, 0.4),
    0 1px 3px rgba(0, 0, 0, 0.2);
}

.nickname {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 30px;
  font-weight: 600;
  font-style: italic;
  justify-content: space-between;
  color: #fff;
  text-shadow: 0 0.5px 0 rgba(0, 0, 0, 0.3);
}

.total-inner {
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 4px 0 0 4px;
  color: #fff;
  font-weight: 600;
  text-shadow: 0 0.5px 0 rgba(0, 0, 0, 0.3);
  padding-left: 6px;
  /* border-left: 1px solid rgba(255, 255, 255, 0.25); */
}

.carousel-indicators {
  position: absolute;
  bottom: 50px;
  right: 15%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}

.carousel-indicators span {
  width: 48px;
  height: 48px;
  font-size: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(180, 175, 170, 0.85) 0%, rgba(130, 125, 120, 0.8) 100%);
  cursor: pointer;
  transition: all 0.3s;
  line-height: 48px;
  text-align: center;
  color: #fff;
  font-weight: 600;
  border: 1px solid rgba(160, 155, 150, 0.5);
  box-shadow: 
    0 1px 4px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.carousel-indicators span.active {
  background: linear-gradient(135deg, rgb(255 96 96 / 90%) 0%, rgb(255 48 48 / 85%) 50%, rgb(232 1 1 / 90%) 100%);
  border-color: #cc0000;
  box-shadow: 
    0 0 10px rgba(255, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.5),
    0 2px 4px rgba(0, 0, 0, 0.2);
  transform: scale(1.05);
}

.pause-con {
  position: absolute;
  bottom: 120px;
  right: 15%;
  width: 110px;
  height: 50px;
  transform: translateX(-50%);
}

.pause-con > button {
  width: 100%;
  height: 100%;
  cursor: pointer;
  line-height: 40px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, rgb(255 96 96 / 90%) 0%, rgb(255 48 48 / 85%) 50%, rgb(232 1 1 / 90%) 100%);
  border: 2px solid #cc0000;
  border-radius: 8px;
  box-shadow: 
    0 0 10px rgba(255, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.5),
    0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
}

.pause-con > button:hover {
  transform: translateY(-1px);
  box-shadow: 
    0 0 15px rgba(255, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.6),
    0 3px 6px rgba(0, 0, 0, 0.25);
}

.pause-con > button:active {
  transform: translateY(0);
  box-shadow: 
    0 0 8px rgba(255, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.4),
    0 1px 3px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/page260618/page0517.vue